import GoogleSource from "./google/googlesource";
import {BaseSource} from "location.core";

/**
 * Creates Source using code and source init params
 */
export default class SourceFactory
{
	static createSource(sourceCode: string , sourceParams: Object): BaseSource
	{
		//todo: make the event for custom and tests sources.
		if(sourceCode === 'GOOGLE')
		{
			let params = Object.assign({}, sourceParams);
			params.languageId = BX.message('LANGUAGE_ID');
			return new GoogleSource(params);
		}
		else
		{
			throw new Error('WrongSourceType', 'Source "' + sourceCode + '" does not exist');
		}
	}
}